import { Suspense } from "react";

import Dim from "@/components/shared/ui/Dim/Dim";
import Loader from "@/components/shared/ui/Loader/Loader";
import { setDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

import Pagination from "./components/Pagination/Pagination";
import RegulatoryTable from "./components/RegulatoryTable/RegulatoryTable";
import RegulatoryTableFilter from "./components/RegulatoryTableFilter/RegulatoryTableFilter";
import { useSetScrollPosition } from "./hooks/useSetScrollPosition";
import * as S from "./RegulatoryContainer.style";

const RegulatoryContainer = () => {
  useSetScrollPosition();
  setDealTypeDisplayName();

  return (
    <S.RegulatoryListWrapper>
      <Suspense
        fallback={
          <Dim>
            <Loader />
          </Dim>
        }
      >
        <RegulatoryTableFilter />
        <RegulatoryTable />
        <Pagination />
      </Suspense>
    </S.RegulatoryListWrapper>
  );
};

export default RegulatoryContainer;
